<template>
  <div v-bind:class="article_class" @change_mode="changeMode">

  <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      mode_class: ""
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "chat-section") {
        this.changeMode("chat");
      }
      else {
        this.changeMode("");
      }
    }
  },
  computed: {
    article_class: function() {
      return "wrapper " + this.mode_class
    }
  },
  methods: {
    changeMode(event) {
      this.mode_class = event;
    },
    goToChat() {
      this.$router.push('/chat/situation/new/');
      this.changeMode("chat");
    }
  }
}
</script>

<style lang="scss">
@import "assets/scss/main.scss";
</style>
